module.exports = __webpack_public_path__ + "media/images/official/about_comipla_image1_4-d0c252b92a500daec7619cdf6f0a5ec6.jpg";